/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type loginOkta_viewer$ref: FragmentReference;
declare export opaque type loginOkta_viewer$fragmentType: loginOkta_viewer$ref;
export type loginOkta_viewer = {|
  +id: string,
  +actualPersonId: ?string,
  +$refType: loginOkta_viewer$ref,
|};
export type loginOkta_viewer$data = loginOkta_viewer;
export type loginOkta_viewer$key = {
  +$data?: loginOkta_viewer$data,
  +$fragmentRefs: loginOkta_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "loginOkta_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
// prettier-ignore
(node/*: any*/).hash = '061530426c9bfb9e974c887858af1d7f';

module.exports = node;
